import { Add, GridView } from "@mui/icons-material";
import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";

function SunlightRates() {
    const location = useLocation();
    const path = location.pathname.split("/")[2];
    const name = path.replace("-", " ");

    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />

                    <span> {name} </span>
                </div>
                <Link to="/dashboard/sunlight-rates/create">
                    <ButtonTable startIcon={<Add />}>New</ButtonTable>
                </Link>
            </HeaderTable>
            <Outlet />
        </>
    );
}

export default SunlightRates;
